// components/generated/MarkdownRenderer.tsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box } from '@chakra-ui/react';

interface MarkdownRendererProps {
	content: string;
	[key: string]: any;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, ...props }) => {
	return (
		<Box {...props}>
			<ReactMarkdown>{content}</ReactMarkdown>
		</Box>
	);
};

export default MarkdownRenderer;